import { cva } from 'class-variance-authority';

/**
 * Toggle component variant styles using CVA for consistent styling.
 */
export const toggleVariants = cva([
  // Container styles
  'inline-flex items-center gap-3',
]);

/**
 * Toggle switch variant styles
 */
export const toggleSwitchVariants = cva([
  // Base switch styles
  'relative inline-flex h-6 w-11 items-center rounded-full',
  'border-2 border-transparent',
  'transition-colors duration-200 ease-in-out',
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
  'focus-visible:outline-[var(--color-brand-primary)]',
  'cursor-pointer',
], {
  variants: {
    checked: {
      true: 'bg-[var(--color-brand-primary)]',
      false: 'bg-gray-200',
    },
    disabled: {
      true: 'cursor-not-allowed opacity-50',
      false: '',
    },
  },
  defaultVariants: {
    checked: false,
    disabled: false,
  },
});

/**
 * Toggle thumb variant styles
 */
export const toggleThumbVariants = cva([
  // Base thumb styles
  'inline-block h-4 w-4 rounded-full bg-white',
  'shadow ring-0 transition duration-200 ease-in-out',
  'pointer-events-none',
  'transform',
], {
  variants: {
    checked: {
      true: 'translate-x-5',
      false: 'translate-x-1',
    },
  },
  defaultVariants: {
    checked: false,
  },
});

/**
 * Toggle label variant styles
 */
export const toggleLabelVariants = cva([
  // Base label styles
  'text-sm font-medium text-neutral-black',
  'cursor-pointer select-none',
], {
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-50',
      false: '',
    },
  },
  defaultVariants: {
    disabled: false,
  },
});